export default {
  "content": "<path d=\"M4.5 14.25c0 .825.675 1.5 1.5 1.5h6c.825 0 1.5-.675 1.5-1.5v-9h-9v9zm2.378-4.807a.747.747 0 111.057-1.058L9 9.443l1.057-1.058a.747.747 0 111.058 1.058L10.057 10.5l1.058 1.057a.747.747 0 11-1.058 1.058L9 11.557l-1.058 1.058a.747.747 0 11-1.057-1.058L7.943 10.5 6.877 9.443zM13.5 3h-1.875l-.533-.533a.757.757 0 00-.524-.217H7.433a.757.757 0 00-.526.217L6.375 3H4.5a.752.752 0 00-.75.75c0 .412.338.75.75.75h9c.412 0 .75-.338.75-.75A.752.752 0 0013.5 3z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "18",
    "height": "18",
    "fill": "#707070",
    "viewBox": "0 0 18 18"
  }
};